import { useVendor } from '../context/vendor';
import ContactUsWhatsAppButton from '../component/ContactUsWhatsAppButton';
import { useTranslation } from './translations';
import { IMenuItem } from '../context/layout/types';

const useDefaultMenuItems = (): IMenuItem[] => {
    const { t } = useTranslation('common');
    const { vendor } = useVendor();
    const message = `${t("Hi, I'm at")} ${vendor?.name} ${t("and I'm reaching out because")}`;

    return [
        ...(vendor?.config?.restaurantMobileNumber
            ? [
                  {
                      href: `https://wa.me/${vendor?.config?.restaurantMobileNumber}?text=${message}`,
                      title: <ContactUsWhatsAppButton />,
                      keepOnRouteChange: true,
                  },
              ]
            : []),
    ];
};

export default useDefaultMenuItems;
